import { ContactCardType as ApiContactCardType } from 'src/api/generated/touring/types';
import { CompanyLinkContactCardType } from '../../../mapPersonType/types';

export const mapContactCardType = (
  contactCard: ApiContactCardType | null
): CompanyLinkContactCardType | null => {
  if (!contactCard) {
    return null;
  }

  return {
    shareUrl: contactCard.shareUrl,
    createdAt: contactCard.createdAt,
    hits: contactCard.hits,
    vcardDownloads: contactCard.vcardDownloads,
    lastAccessAt: contactCard.lastAccessAt,
  };
};
